import "../../index.css";
import CoverTitle from "../CoverTitle/CoverTitle";
import "./ContactGroup.css";

const ContactGroup = ({
  iconClass,
  children, 
  clr = "white",
  marginClass
}) => {
  return (
    <div  className={`contact-group flex-column-centered ${clr && `${clr}` } ${marginClass && marginClass }`}>
      <i className={`${iconClass && iconClass} ${clr && clr} ${marginClass && marginClass } contact-icon`}></i>
      <CoverTitle class_Name={`${clr && `${clr}`} ${marginClass && marginClass} `}>{children}</CoverTitle>
    </div>
  );
};

export default ContactGroup;